<template>
  <v-dialog
    v-model="dialogInstructionsPassword"
    persistent
    max-width="500">
    <v-card>
      <v-toolbar dark color="success">
        <v-toolbar-title>
          <v-icon>mdi-verified mdi-24px</v-icon>
          Validação concluída. Siga os passos!
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-card-text>
        <ol>
          <li>Acesse seu e-mail</li>
          <li>Leia todas instruções</li>
          <li>Abra o link e prossiga com segurança</li>
        </ol>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          color="success"
          @click="closeDialogInstructions">
          Entendi
        </v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DialogInstructionsPassword',
  computed: {
    dialogInstructionsPassword() {
      return this.$store.getters.dialogInstructionsPassword;
    },
  },
  methods: {
    closeDialogInstructions() {
      this.$store.dispatch('toggleInstructionsPassword', false);
      this.$router.push('/');
    },
  },
};
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/authentication/password/recovery/DialogInstructionsPassword.vue